<template>
<div class="wrapper">

<router-view></router-view>
</div>
</template>
<script>
	//import Page1 from './Page1'
  
  export default {
      name: 'App2',
      
    }
</script>